import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CarrinhoItem } from '@app/data/carrinhoItem/carrinho-item.model';
import { BaseService } from '@app/shared/services/base';
import { CarrinhoService } from '../carrinho.service';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemComponent {
  @Input() public readonly item: CarrinhoItem;

  constructor(private _base: BaseService, private _carrinhoService: CarrinhoService) {}

  public getFoto(foto: any): string {
    return foto?.url;
  }

  public async incrementItem(item: CarrinhoItem) {
    this._base._loading.start();

    await this._carrinhoService
      .increment(item.id, item.carrinhoId)
      .catch((e) => {
        this._base._alert.error('Atenção', e);
      })
      .finally(() => {
        this._base._loading.stop();
        this._carrinhoService.atualizarCarrinho();
      });
  }

  public async decrementItem(item: CarrinhoItem) {
    this._base._loading.start();

    await this._carrinhoService
      .decrement(item.id, item.carrinhoId)
      .catch((e) => {
        this._base._alert.error('Atenção', e);
      })
      .finally(() => {
        this._base._loading.stop();
        this._carrinhoService.atualizarCarrinho();
      });
  }

  public removerItem(item: CarrinhoItem) {
    this._base._loading.start();

    this._carrinhoService
      .remove(item.id, item.carrinhoId)
      .then(
        () => {
          this._base._toast.success('Item removido');
        },
        (err) => {
          this._base._alert.error('Atenção', err);
        }
      )
      .finally(() => {
        this._base._loading.stop();
        this._carrinhoService.atualizarCarrinho();

        this._base.analyticsEvents.itemRemovidoDoCarrinho(item.produto);

        window.location.reload();
      });
  }
}
